import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import AuthRouteModeration from '../../../utils/authRouteModeration';

import StatusesTransitions from '../../../pages/moderation/flow/statusesTransitions';

import { StatusesTab, StatusDetails } from '../../../pages/moderation/flow/statusesTransitions/statuses';
import { TransitionsTab, TransitionDetails } from '../../../pages/moderation/flow/statusesTransitions/transitions';
import { ActionDetails, ActionsTab } from '../../../pages/moderation/flow/statusesTransitions/actions';
import { ConditionDetails, ConditionsTab } from '../../../pages/moderation/flow/statusesTransitions/conditions';

const StatusTransitionsRouter = ({ path, url, organization }) => {
    return (
        <Switch>
            <Route
                exact
                path={`${path}/`}
                render={() => {
                    let redirect = `${url}/statuses`;
                    if (url[url.length - 1] === '/') {
                        redirect = `${url}statuses`;
                    }
                    return <Redirect to={redirect} />;
                }}
            />

            <Route
                exact
                path={`${path}/statuses`}
                render={({ match }) => (
                    <StatusesTransitions organization={organization} flowId={match.params.flowId} path={url} index={0}>
                        <StatusesTab />
                    </StatusesTransitions>
                )}
            />
            <Route exact path={`${path}/statuses/new`} render={({ match }) => <StatusDetails organization={organization} flowId={match.params.flowId} />} />
            <Route
                exact
                path={`${path}/statuses/:statusId`}
                render={({ match }) => <StatusDetails organization={organization} flowId={match.params.flowId} statusId={match.params.statusId} />}
            />

            <Route
                exact
                path={`${path}/transitions`}
                render={({ match }) => (
                    <StatusesTransitions organization={organization} flowId={match.params.flowId} path={url} index={1}>
                        <TransitionsTab />
                    </StatusesTransitions>
                )}
            />
            <Route exact path={`${path}/transitions/new`} render={({ match }) => <TransitionDetails organization={organization} flowId={match.params.flowId} />} />
            <Route
                exact
                path={`${path}/transitions/:transitionId`}
                render={({ match }) => <TransitionDetails organization={organization} flowId={match.params.flowId} transitionId={match.params.transitionId} />}
            />

            <AuthRouteModeration
                exact
                allow={['PyvarCapacity.ADMIN']}
                path={`${path}/actions`}
                render={({ match }) => (
                    <StatusesTransitions organization={organization} flowId={match.params.flowId} path={url} index={2}>
                        <ActionsTab path={url} />
                    </StatusesTransitions>
                )}
            />
            <AuthRouteModeration
                exact
                allow={['PyvarCapacity.ADMIN']}
                path={`${path}/actions/new`}
                render={({ match }) => <ActionDetails organization={organization} flowId={match.params.flowId} />}
            />
            <AuthRouteModeration
                exact
                allow={['PyvarCapacity.ADMIN']}
                path={`${path}/actions/:actionId`}
                render={({ match }) => <ActionDetails organization={organization} flowId={match.params.flowId} actionId={match.params.actionId} />}
            />

            <AuthRouteModeration
                exact
                allow={['PyvarCapacity.ADMIN']}
                path={`${path}/conditions`}
                render={({ match }) => (
                    <StatusesTransitions organization={organization} flowId={match.params.flowId} path={url} index={3}>
                        <ConditionsTab />
                    </StatusesTransitions>
                )}
            />
            <AuthRouteModeration
                exact
                allow={['PyvarCapacity.ADMIN']}
                path={`${path}/conditions/new`}
                render={({ match }) => <ConditionDetails organization={organization} flowId={match.params.flowId} />}
            />
            <AuthRouteModeration
                exact
                allow={['PyvarCapacity.ADMIN']}
                path={`${path}/conditions/:conditionId`}
                render={({ match }) => <ConditionDetails organization={organization} flowId={match.params.flowId} conditionId={match.params.conditionId} />}
            />
        </Switch>
    );
};

export default StatusTransitionsRouter;
